import { useSearchQueryFilter } from '@aibees/elephant/hooks';
import { Icon } from '@aibees/shared/components';
import { classnames } from '@aibees/shared/utils';
import { Box, Checkbox, Tooltip, Typography } from '@mui/material';
import { memo } from 'react';
import * as SX from './sx';
import type { PresentSwitchFilterProps as Props } from './types';
import { usePresentChecked } from './use-present-checked';
import { buildDraft } from './utils';

const POPPER_PROPS_DISABLE_PORTAL = { disablePortal: true };

export const PresentSwitchFilter = memo(
  ({ className, field, metadata }: Props) => {
    const { setParam, params } = useSearchQueryFilter({
      select: [field!],
    });
    const checked = usePresentChecked(field!);

    const handleSwitchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
      const draft = buildDraft(field!, params, event.target.checked);
      if (draft.length) setParam(field!, draft);
    };
    return (
      <Box
        className={classnames('PresentSwitchFilter', className)}
        display={'flex'}
        alignItems={'center'}
        gap={0.5}
        sx={SX.root}
      >
        <Checkbox checked={checked} onChange={handleSwitchChange} />

        <Typography variant="body4" color="grey.500">
          {metadata?.numberRange?.switch?.title}
        </Typography>

        {metadata?.numberRange?.switch?.info && (
          <Tooltip
            PopperProps={POPPER_PROPS_DISABLE_PORTAL}
            title={metadata?.numberRange?.switch?.info}
            arrow
            placement="top"
          >
            <Icon name="info" size={12} color="primary" />
          </Tooltip>
        )}
      </Box>
    );
  }
);

PresentSwitchFilter.displayName = 'PresentSwitchFilter';
